// extracted by mini-css-extract-plugin
module.exports = {"googleButton":"googleSigninButton_googleButton__m29S9"};